


































import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Data/Enums
import { CancelOptions } from "@/data/enums/contracts";
import {
  IContractCancellationProvider as ICCProvider,
  IContractCancellationMethods as ICCMethods,
  ICancelOption
} from "@/models/providers/contractCancellation";

@Component
export default class ContractCancellationOptions extends Mixins(Context) {
  // Inject
  @Inject({ from: "contractCancellationProvider" })
  public readonly $provider!: () => ICCProvider;
  @Inject({ from: "contractCancellationMethods" })
  public readonly $methods!: ICCMethods;
  // Computed
  public get provider() {
    return this.$provider();
  }
  public get cancelOption() {
    return this.$_.find(this.provider.cancelOptions, [
      "id",
      this.provider.cancelOption
    ]);
  }
  // Life-cycle methods
  public created() {
    if (this.provider.contractProduct.renew === false) {
      // Pre-select if auto-renew is off
      this.$methods.selectCancelOption({
        id: CancelOptions.CANCEL_AFTER_CURRENT_TERM
      } as ICancelOption);
    } else {
      if (this.isAdmin) {
        // Otherwise pre-select first cancellation option
        this.$methods.selectCancelOption(this.provider.cancelOptions[0]);
      } else {
        if (!this.$_.get(this.provider, "contractProduct.renew", true)) {
          this.$methods.selectCancelOption(
            this.provider.cancelOptions[
              this.$_.findIndex(this.provider.cancelOptions, [
                "id",
                CancelOptions.CANCEL_AFTER_CURRENT_TERM
              ])
            ]
          );
        }
      }
    }
  }
}
